import { queryOptions } from '@tanstack/react-query'

import { getUserMe } from './get-user-me'

export const userQueries = {
  all: () => ['user'],
  userMe: () =>
    queryOptions({
      queryKey: [...userQueries.all(), 'me'],
      queryFn: () => getUserMe(),
    }),
}
